import React from 'react';

import { func, oneOf, string } from 'prop-types';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import styled from 'styled-components';

const StyledFaArrowRight = styled(FaArrowRight)``;
const StyledFaArrowLeft = styled(FaArrowLeft)``;

const CarouselArrowButton = styled.button`
  width: 32px;
`;

const ArrowStyleWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const GridArrow = props => {
  const { className, onClick, scrollDirection = 'next', ...rest } = props;

  return (
    <CarouselArrowButton
      className={className}
      onClick={onClick}
      shouldShow={Boolean(onClick)}
      {...rest}
    >
      <ArrowStyleWrapper>
        {scrollDirection === 'next' ? (
          <StyledFaArrowRight size={20} title="Next slide" />
        ) : (
          <StyledFaArrowLeft size={20} title="Previous slide" />
        )}
      </ArrowStyleWrapper>
    </CarouselArrowButton>
  );
};

GridArrow.propTypes = {
  className: string,
  onClick: func,
  scrollDirection: oneOf(['next', 'previous']),
};

export default GridArrow;
